import * as React from 'react';
import classNames from 'classnames';
import {Flex, Text, Currency} from 'components/UIKit';
import * as styles from './CardMetric.scss';

interface Metric {
  label: string;
  frequency?: string;
  value: number;
  emphasis?: boolean;
  display?: boolean;
}

interface CardMetricProps {
  metric: Metric;
  layout: string;
}

export function CardMetric({metric, layout}: CardMetricProps) {
  const getClassName = (base: string) =>
    classNames(base, styles[layout], {
      [styles.emphasis]: metric.emphasis,
    });

  return (
    <Flex className={getClassName(styles.metric)}>
      <Flex wrapperComponent="dt" className={getClassName(styles.metricLabelWrapper)}>
        <Text
          className={getClassName(styles.metricLabel)}
          text={metric.label}
          type="small"
          resetMargin
        />
        {metric.frequency && (
          <Text type="small" secondary text={` /${metric.frequency}`} component="p" resetMargin />
        )}
      </Flex>
      <dd className={styles.noMargin}>
        {metric.value ? (
          <Currency
            value={metric.value}
            className={getClassName(styles.metricValue)}
            display={null}
            emphasis={metric.emphasis}
            condensed
          />
        ) : (
          <p className={getClassName(styles.metricValue)}>—</p>
        )}
      </dd>
    </Flex>
  );
}
